module.exports = __webpack_public_path__ + "d96b9e23c33feaa19b90a816579c098f.glb";